import React from "react";
import { Icon } from "../ui";
import { cn } from "@/lib/utils";

/**
 * Mobile device chrome for dashboard Link in Bio preview. Inner screen uses the same
 * light canvas as the public page so typography stays readable.
 */
export function LinkInBioPhoneFrame({ children, className }) {
  return (
    <div
      className={cn("mx-auto w-full max-w-[300px]", className)}
      data-testid="link-in-bio-preview-phone-frame"
    >
      <div className="rounded-[2.35rem] border-[11px] border-slate-800 bg-slate-950 p-1.5 shadow-2xl ring-1 ring-white/10">
        <div className="overflow-hidden rounded-[1.85rem] bg-[#fafafa]">
          <div className="flex justify-center pt-2 pb-1">
            <div
              className="h-5 w-[88px] rounded-full bg-slate-950"
              aria-hidden
            />
          </div>
          <div className="max-h-[min(520px,65vh)] min-h-[min(440px,58vh)] overflow-y-auto px-3 pt-2 pb-8">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

/**
 * Browser window chrome for dashboard Link in Bio preview.
 */
export function LinkInBioBrowserFrame({ url, tabLabel, children, className }) {
  const displayUrl = url?.trim() || "https://…";

  return (
    <div
      className={cn(
        "w-full max-w-xl overflow-hidden rounded-lg border border-slate-300/90 bg-slate-200 shadow-2xl",
        className,
      )}
      data-testid="link-in-bio-preview-browser-frame"
    >
      <div className="flex h-9 items-center gap-2 border-b border-slate-300/90 bg-slate-300/80 px-3">
        <span className="h-2.5 w-2.5 rounded-full bg-[#ff5f57]" aria-hidden />
        <span className="h-2.5 w-2.5 rounded-full bg-[#febc2e]" aria-hidden />
        <span className="h-2.5 w-2.5 rounded-full bg-[#28c840]" aria-hidden />
      </div>
      <div className="border-b border-slate-200 bg-white px-2 pt-2">
        <div className="inline-block rounded-t-md border border-b-0 border-slate-200 bg-white px-3 py-1.5 text-xs font-medium text-slate-700">
          {tabLabel}
        </div>
      </div>
      <div className="flex min-h-10 items-center gap-2 border-b border-slate-200 bg-slate-50 px-3 py-1.5">
        <Icon
          name="Lock"
          className="h-3.5 w-3.5 shrink-0 text-emerald-600"
          aria-hidden
        />
        <span className="truncate font-mono text-[11px] text-slate-700">
          {displayUrl}
        </span>
      </div>
      <div className="max-h-[min(520px,65vh)] min-h-[min(440px,58vh)] overflow-y-auto bg-[#fafafa] px-4 pt-6 pb-10">
        {children}
      </div>
    </div>
  );
}
